// Post-application journey, after Banking Details:
// Aadhaar e-KYC → Account Aggregator → thank you. Both checks are mandatory (no skip).
export const EKYC_STEP_PATH = '/my-dashboard/ekyc';
export const AA_STEP_PATH = '/my-dashboard/verify-bank';
export const THANK_YOU_PATH = '/my-dashboard/thank-you';
